/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { mergeQueryKeys } from "./queryKeyHelpers";

export const invalidateQueryKeys = async (queryClient, queryKeys = []) => {
  if (!queryClient) {
    return;
  }

  const normalizedQueryKeys = mergeQueryKeys(queryKeys);

  if (!normalizedQueryKeys.length) {
    return;
  }

  await Promise.all(
    normalizedQueryKeys.map((queryKey) =>
      queryClient.invalidateQueries({ queryKey })
    )
  );
};

export const invalidateQueryGroups = async (queryClient, ...queryKeyGroups) =>
  invalidateQueryKeys(queryClient, queryKeyGroups.flat());
